var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5956_45575)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2 1.99687C1.64772 1.99687 1.2 2.44459 1.2 2.99687V8.53964L4.13907 5.01276C4.24699 4.88326 4.40441 4.80513 4.57281 4.79749C4.74121 4.78985 4.90506 4.85341 5.02426 4.97261L8.70514 8.65348L9.73907 7.41276C9.84699 7.28326 10.0044 7.20513 10.1728 7.19749C10.3412 7.18985 10.5051 7.25341 10.6243 7.37261L12.8 9.54835V2.99687C12.8 2.44459 12.3523 1.99687 11.8 1.99687H2.2ZM14 10.9969V2.99687C14 1.78185 13.015 0.796875 11.8 0.796875H2.2C0.984974 0.796875 0 1.78185 0 2.99687V10.1923V10.2008V10.9969C0 12.2119 0.984974 13.1969 2.2 13.1969H6.19542C6.19826 13.1969 6.2011 13.1969 6.20394 13.1969H11.8C13.015 13.1969 14 12.2119 14 10.9969ZM12.7749 11.2203L10.2403 8.68572L7.48103 11.9969H11.8C12.2755 11.9969 12.6734 11.665 12.7749 11.2203ZM5.91897 11.9969L7.93375 9.57915L4.64032 6.28572L1.2 10.4141V10.9969C1.2 11.5492 1.64772 11.9969 2.2 11.9969H5.91897Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5956_45575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.77b7251046a53195e47791f4f60cea50.svg";
export { ForwardRef as ReactComponent };